__turbopack_context__.v({
  "caption": "C9ekGG_caption",
  "cell": "C9ekGG_cell",
  "headerCell": "C9ekGG_headerCell",
  "lg": "C9ekGG_lg",
  "numeric": "C9ekGG_numeric",
  "row": "C9ekGG_row",
  "sm": "C9ekGG_sm",
  "sortButton": "C9ekGG_sortButton",
  "sortIcon": "C9ekGG_sortIcon",
  "sortIconActive": "C9ekGG_sortIconActive",
  "stackContainer": "C9ekGG_stackContainer",
  "stacked": "C9ekGG_stacked",
  "stickyHeader": "C9ekGG_stickyHeader",
  "striped": "C9ekGG_striped",
  "table": "C9ekGG_table",
  "visuallyHidden": "C9ekGG_visuallyHidden",
  "wrapper": "C9ekGG_wrapper",
});
